<h1>Házicsoportjaink</h1>

<p>
  Azt olvassuk a Bibliában, hogy az első gyülekezetben az emberek "kitartóan részt vettek az apostoli tanításban, egy
  szívvel, egy lélekkel minden nap ott voltak a templomban, és házanként összejöttek, ahol megtörték a kenyeret, és
  együtt voltak, közösségben". Mi is szeretnénk valami hasonlót megvalósítani, ezért gyülekezetünk felépítésében nagyon
  nagy szerepe van a házicsoportoknak.
</p>

<p>
  Egy ilyen alkalom a csoport valamely tagjánál, házánál van, általában változik, hogy éppen kinél. Közelebbről, jobban
  megismerhetjük egymást egy ilyen kis csoportban, mint a gyülekezetben. Nem egy (vagy több) tanítótól hallunk
  gondolatokat, hanem egy adott témával kapcsolatban van egy beszélgetés, mindenki hozzá teheti a saját gondolatait,
  véleményét. Nagyon építőek ezek az alkalmak.
</p>

<p>
  A "beszélgetős részen" kívül rend szerint van valamilyen étel is, amit közösen elfogyasztunk, szoktunk énekelni is
  néhány dalt, és még az is előfordulhat, hogy valamilyen játékra is sor kerül.
</p>

<p>
  Minden héten pénteken tartjuk ezeket az összejöveteleket, jelenleg hat csoportban. A gyülekezet minden tagja
  eldöntheti, hogy szeretne-e valamelyik csoporthoz csatlakozni, ahova azután rendszeresen eljár. Ez nem kötelező, és
  ellenkező esetben sincs semmi féle megrovás érte, de mindenkinek nagyon ajánljuk.
</p>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/homegroups/homegroups.component.html